<template>
    <el-dialog v-if="import_type=='goods'" style="text-align: center" title="导入资源" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-steps :active="active" finish-status="success" align-center style="margin-bottom: 50px">
            <el-step title="文件导入" description="选择上传文件" icon="el-icon-upload"></el-step>
        </el-steps>

        <div v-if="active ==0">
            <el-upload
                    class="upload-demo"
                    drag
                    ref="upload"
                    :on-success="onSuccess"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-exceed="onExceed"
                    :on-remove="onRemove"
                    :on-change="onChange"
                    :before-remove="beforeRemove"
                    :action="action"
                    :with-credentials="true"
                    :disabled="dis"
                    :data="addons"
                    :limit="max_upload"
                    :auto-upload="false"
                    multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip"></div>
            </el-upload>
        </div>

        <el-button v-if="active == 0" type="primary" :disabled="lock_upload" style="margin-top: 12px;" @click="submitUpload">确定</el-button>

    </el-dialog>
        
     <el-dialog v-else-if="import_type=='order'" style="text-align: center" title="导入资源" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">       
        <el-steps :active="active" finish-status="success" align-center >
            <el-step title="文件导入" description="选择上传文件" icon="el-icon-upload"></el-step>
        </el-steps>
        <div style="margin: 20px;text-align: center;">
            <el-radio-group v-model="type">
                <el-radio  label="1" @change="setVal(1)">默认导入</el-radio>
                <el-radio  label="2" @change="setVal(2)">抖音导入</el-radio>
            </el-radio-group>
        </div>
        <div v-if="active ==0">
            <el-upload
                    class="upload-demo"
                    drag
                    ref="upload"
                    :on-success="onSuccess"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-exceed="onExceed"
                    :on-remove="onRemove"
                    :on-change="onChange"
                    :before-remove="beforeRemove"
                    :action="action"
                    :with-credentials="true"
                    :disabled="dis"
                    :data="addons"
                    :limit="max_upload"
                    :auto-upload="false"
                    multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip"></div>
            </el-upload>
        </div>

        <el-button v-if="active == 0" type="primary" :disabled="lock_upload" style="margin-top: 12px;text-align: center;" @click="submitUpload">确定</el-button>
    </el-dialog>
</template>

<script>
    import ImportApi from '@/api/import.js';
    export default {
        data() {
            return {
                /*是否显示*/
                loading: false,
                dialogVisible: false,
                /* 上传文件后缀白名单 */
                domin:['xlsx','xls','zip'],
                /* 上传文件大小限制  mb */
                max_size:'10',
                formInline:{},
                /* 下一步锁 */
                lock_next:true,
                /* 上传锁 */
                lock_upload:true,
                dis:false,
                active: 0,
                /* 最大上传个数 */
                max_upload:1,
                addons:{},
                action:'',
                import_type:'',
                type:'1'
            };
        },
        created() {
            this.dialogVisible = this.$parent.open_upload;
            this.import_type = this.$parent.import_type;
            this.upload_url()
        },
        methods: {
            upload_url(){
                if(this.import_type == 'goods'){
                    // 商品导入
                    ImportApi.uploadUrl('',true)
                        .then(data => {
                            this.action = 'http://' + data.data.list + '/index.php/shop/plus.data.import/excel_upload'
                            // console.log(this.action)
                        })
                        .catch(error => {

                        });
                    
                }else if(this.import_type == 'order'){
                    
                    // 订单导入
                    ImportApi.uploadUrl('',true)
                        .then(data => {
                            this.action = 'http://' + data.data.list + '/index.php/shop/plus.data.import/order_import'
                            // console.log(this.action)
                        })
                        .catch(error => {

                        });

                }

            },

            submitUpload() {
                this.$refs.upload.submit();
            },
            onChange(file,fileList){
                this.lock_upload = false
                console.log(file)
                console.log(fileList)
            },

            onSuccess(response,file,fileList){
                let self = this
                console.log(response)
                this.active++;
                this.lock_upload = true
                this.dialogVisible = false
                this.$notify({
                    title: '成功',
                    message: '导入成功',
                    type: 'success'
                });
                this.$parent.getData();
                return false;
            },
            beforeUpload(file){
             //   console.log(file)
                let self = this
                let dof = file.name.split('.')
                if (self.domin.indexOf(dof[1]) < 0){
                    this.$message({
                        type: 'info',
                        message: '不被允许的格式'
                    });
                    return false;
                }
                if ((self.max_size)*1024*1024 < file.size){
                    this.$message({
                        type: 'info',
                        message: '文件最大只允许' + self.max_size + "mb"
                    });
                    return false;
                }
            },
            beforeRemove(file,fileList){
                if(fileList.length == 1){
                    this.lock_upload = true
                }
            },
            onRemove(file,fileList){
                if(fileList.length == 0){
                    this.lock_upload = true
                }
            },
            /* 文件上传失败时的钩子    */
            onError(){
                this.$message({
                    type: 'info',
                    message: '文件上传失败'
                });
                this.lock_upload = true
                return false;
            },
            /* 文件超出个数限制时的钩子  */
            onExceed(){
                this.$message({
                    type: 'info',
                    message: '最大上传文件个数为'+this.max_upload+"个"
                });
                return false;
            },
            setVal(e){
                // console.log(e);
                if(this.import_type == 'order'){
                    this.action = this.action+'?type='+e
                }
            },
            /*关闭弹窗*/
            dialogFormVisible(e) {
                if (e) {
                    this.$emit('closeDialog', {
                        type: 'success',
                        openDialog: false
                    })
                } else {
                    this.$emit('closeDialog', {
                        type: 'error',
                        openDialog: false
                    })

                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/file/import.vue